
import { mapState, mapGetters } from 'vuex'
import bankAccountDesktop from '~/mixins/common/bank-account-desktop'
import finance from '~/mixins/common/pages/finance'
export default {
    mixins: [finance, bankAccountDesktop],
    data() {
        return {
            paymentType: 'bank',
            steppers: 1,
            selectedBank: 1,
            formValid: true,
            cryptoValid: true,
            form: {
                amount: null,
            },
            cryptoForm: {
                currency: null,
                amount: null,
            },
            resultData: {},
            existLoading: false,
            forceToAddBankAccountModal: false,
            forceToAddWalletAddressModal: false,
            disabledToWithdrawal: false,
            selectedBankId: null,
            amount: '0',
            pleaseSelectedBankId: false,
            formattedAmount: {
                amount: '',
                cryptoAmount: '',
            },
            disabledBank: false,
            disabledCrypto: false,
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.themes.withdraw.loading,
            player: (state) => state.player.player,
            verifyCurrency: (state) => state.banks.verifyCurrency,
            cryptoCurrencyList: (state) =>
                state.settings.cryptoWalletAddressList,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
            depositFlow: (state) => state.themes.deposit.depositFlow,
            operationSetting: (state) => state.settings.operationSetting,
            exchangeRateLoading: (state) =>
                state.themes.settings.exchangeRateLoading,
            exchangeRateByPlayerCurrency: (state) =>
                state.themes.settings.exchangeRateByPlayerCurrency,
            companyCryptoWalletForWithdrawal: (state) =>
                state.themes.withdraw.companyCryptoWalletForWithdrawal,
        }),
        ...mapGetters({
            exchangeRates: 'themes/settings/exchangeRate',
            swapAllExchangeRate: 'themes/settings/swapAllExchangeRate',
        }),
        withdrawalMinAndMaxAmount() {
            // Since the Lao and international are having different API endpoints to check the min and max amount of withdrawal
            if (this.isInternational) {
                return {
                    min: parseFloat(this.operationSetting.withdraw_min || 0),
                    max: parseFloat(this.operationSetting.withdraw_max || 0),
                }
            }
            return {
                min: parseFloat(this.verifyCurrency.withdraw_min || 0),
                max: parseFloat(this.verifyCurrency.withdraw_max || 0),
            }
        },
        withdrawalAmountRule() {
            return [
                (v) =>
                    !!v || this.tr(this.FRONTEND_ERROR_CODES.amountIsRequired),
                (v) =>
                    parseFloat(v?.toString()?.replace(/,/g, '')) > 0 ||
                    this.tr(this.FRONTEND_ERROR_CODES.amountGreaterThanZero),
                (v) =>
                    parseFloat(v?.toString()?.replace(/,/g, '')) <=
                        parseFloat(this.playerRealtimeBalance()) ||
                    this.tr(this.FRONTEND_ERROR_CODES.balanceInsufficient),
                (v) =>
                    (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
                        parseFloat(this.withdrawalMinAndMaxAmount?.min) ||
                    `${this.tr(
                        this.FRONTEND_ERROR_CODES.minimumWithdrawIs
                    )} ${this.formatCurrencyJS(
                        this.withdrawalMinAndMaxAmount.min
                    )}`,
                (v) =>
                    (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
                        parseFloat(this.withdrawalMinAndMaxAmount?.max) ||
                    `${this.tr(
                        this.FRONTEND_ERROR_CODES.maximumWithdrawIs
                    )} ${this.formatCurrencyJS(
                        this.withdrawalMinAndMaxAmount.max
                    )}`,
                (v) =>
                    this.decimalRule(v?.replace(/,/g, '')) ||
                    this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit),
            ]
        },
        primaryBankAccount() {
            const foundBankAccount =
                this.bankAccount?.player_bank_accounts?.find(
                    (account) => account.is_primary
                )
            return foundBankAccount || {}
        },
        exchangeRate() {
            const foundRate = this.exchangeRates.find(
                (rate) =>
                    rate.from_currency === this.player.currency &&
                    rate.to_currency === this.primaryBankAccount.currency
            )
            return foundRate ? foundRate.rate : 0
        },
        cryptoExchangeRate() {
            if (this.exchangeRateLoading) return ''
            if (this.exchangeRateByPlayerCurrency.rate)
                return parseFloat(this.exchangeRateByPlayerCurrency.rate)
            return 1
        },
        cryptoTransferAmount() {
            if (!this.cryptoForm.amount || this.exchangeRateLoading) return ''
            return this.formatCurrencyJS(
                this.cryptoForm.amount * this.cryptoExchangeRate
            )
        },
        destinationCurrency() {
            if (this.bankAccount?.player_bank_accounts?.length > 0) {
                const bankCurrency =
                    this.bankAccount?.player_bank_accounts.find(
                        (el) => el?.id === this.selectedBankId
                    )
                if (bankCurrency) return bankCurrency.currency
                else return null
            }
            return null
        },
        exchangeRateBaseOnPlayerAndBankAccount() {
            const getMatchCurrency = this.exchangeRates.find((el) => {
                if (
                    el.from_currency === this.player.currency &&
                    el.to_currency === this.destinationCurrency
                ) {
                    return true
                }
                return false
            })
            if (getMatchCurrency) {
                return getMatchCurrency.rate
            }
            return 0
        },
        cryptoButtonDisable() {
            if (!this.cryptoForm.player_crypto_wallet_id) return true
            if (!this.formattedAmount.cryptoAmount) return true
            return false
        },
    },
    watch: {
        'formData.amount'(value) {
            if (value) {
                if (!this.verifyCurrency.withdraw_min) {
                    this.$store.dispatch(
                        'banks/verifyCurrency',
                        this.player.currency
                    )
                }
            }
        },
        player(value) {
            if (value.currency) {
                this.checkWebsiteSettings()
                this.checkIfWithdrawalExist()
                if (!this.isInternational)
                    this.$store.dispatch('banks/verifyCurrency', value.currency)
            }
        },
        cryptoCurrencyList(value) {
            if (value.length) {
                this.cryptoForm.currency = value[0].code
            }
        },
        depositFlow(value) {
            // RegFlow = 5 is crypto currency
            if (~~value?.reg_flow === 5) {
                this.paymentType = 'crypto'
            }
        },
        operationSetting(value) {
            // only international
            if (value?.reg_flow) {
                const hasBankAccount = this.player.has_bank_account
                if (hasBankAccount === false && ~~value?.reg_flow === 2) {
                    this.forceToAddBankAccountModal = true
                    this.disabledToWithdrawal = true
                }
            }
        },
        playerCryptoWallets(value) {
            if (value.length === 0) {
                if (this.operationSetting.reg_flow === 5) {
                    this.forceToAddWalletAddressModal = true
                }
            }

            if (value.length > 0) {
                this.cryptoForm.player_crypto_wallet_id = value[0]?.id
            }
        },
    },
    async mounted() {
        if (this.$cookie.get('player')?.currency !== 'USDT')
            this.$store.dispatch(
                'themes/settings/getExchangeRateByPlayerCurrency',
                {
                    currency: this.$cookie.get('player')?.currency,
                }
            )
        await this.checkIfWithdrawalExist()
        this.checkWebsiteSettings()
        // execute only inter wl
        if (this.isInternational) {
            this.$store.dispatch(
                'settings/operationSetting',
                this.$cookie.get('player')?.currency
            )
        }

        this.$root.withdrawExistChange = (item) => {
            if (!item?.is_exist) {
                this.steppers = 1
                this.resultData = {}
            } else {
                this.steppers = 2
                this.resultData = { ...this.resultData, ...item }
            }
            this.onDisablePaymentButtons(item)
        }
        if (!this.isInternational && this.player?.currency) {
            this.$store.dispatch('banks/verifyCurrency', this.player.currency)
        }
        if (!this.cryptoCurrencyList.length) {
            this.$store.dispatch('settings/getCryptoWalletAddressList')
        } else {
            this.cryptoForm.currency = this.cryptoCurrencyList[0].code
        }
        if (!this.playerCryptoWallets.length) {
            this.$store.dispatch('themes/player-bank/playerCryptoWallet')
        }
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    destroyed() {
        this.$root.withdrawExistChange = null
    },
    methods: {
        async doWithdraw() {
            this.$refs?.refWithdraw?.validate()
            if (!this.selectedBankId) this.pleaseSelectedBankId = true

            if (!this.formValid || !this.selectedBankId) return
            this.form.player_bank_account_id = this.selectedBankId

            const result = await this.$store.dispatch(
                'themes/withdraw/createWithdraw',
                this.form
            )
            if (result) {
                this.onDisablePaymentButtons({
                    is_exist: true,
                    payment_provider_code: 'manual_transfer',
                })

                this.resultData = result
                this.steppers = 2
                this.$refs?.refWithdraw?.reset()
            }
        },
        clearForm() {
            this.$refs?.refWithdraw?.reset()
        },
        async cancelPending(item) {
            const confirm = window.confirm(this.tl('uSureToCancel?'))
            if (!confirm) return
            const result = await this.$store.dispatch(
                'themes/withdraw/cancelWithdraw',
                item.id
            )
            if (result) {
                this.onDisablePaymentButtons({ is_exist: false })
                this.resultData = {}
                this.steppers = 1
            }
        },
        async checkIfWithdrawalExist() {
            this.existLoading = true
            if (this.player?.has_bank_account) {
                const result = await this.$store.dispatch(
                    'themes/withdraw/checkExistWithdrawal'
                )
                this.onDisablePaymentButtons(result)
                if (result?.is_exist) {
                    if (result.payment_provider_code === 'crypto') {
                        this.paymentType = 'crypto'
                    }
                    this.resultData = result
                    this.steppers = 2
                }
                this.existLoading = false
            }
        },
        // check website settings conditions
        checkWebsiteSettings() {
            const hasBankAccount = this.player.has_bank_account
            // const registrationType = this.player.registration_type

            if (hasBankAccount === false && !this.isInternational) {
                this.forceToAddBankAccountModal = true
                this.disabledToWithdrawal = true
            }
        },
        onInputAmount(amount) {
            if (isNaN(amount?.replace(/,/g, ''))) {
                if (this.paymentType === 'bank') {
                    this.form.amount = '0'
                } else {
                    this.cryptoForm.amount = '0'
                }
                return
            }
            const formattedAmount = amount
                ? Number.parseFloat(amount?.replace(/,/g, ''))?.toLocaleString()
                : ''
            if (this.paymentType === 'bank') {
                this.formattedAmount.amount = formattedAmount
                this.form.amount = formattedAmount
                    ?.toString()
                    ?.replace(/,/g, '')
            } else {
                this.formattedAmount.cryptoAmount = formattedAmount
                this.cryptoForm.amount = formattedAmount
                    ?.toString()
                    ?.replace(/,/g, '')
            }
        },
        async onCreateCryptoWithdrawal() {
            if (!this.$refs.cryptoForm.validate()) return
            const response = await this.$store.dispatch(
                'themes/withdraw/createCryptoWithdrawal',
                {
                    amount: this.cryptoForm.amount,
                    player_crypto_wallet_id:
                        this.cryptoForm.player_crypto_wallet_id,
                }
            )
            if (response) {
                this.onDisablePaymentButtons({
                    is_exist: true,
                    payment_provider_code: 'crypto',
                })

                this.resultData = response
                this.steppers++
            }
        },
        onDisablePaymentButtons(data) {
            if (data.is_exist === false) {
                this.disabledBank = false
                this.disabledCrypto = false
                return
            }
            if (data.payment_provider_code === 'manual_transfer') {
                this.disabledBank = false
                this.disabledCrypto = true
                return
            }
            if (data.payment_provider_code === 'crypto') {
                this.disabledBank = true
                this.disabledCrypto = false
            }
        },
        changePaymentType(type) {
            if (this.paymentType === 'crypto') {
                this.selectedBankId = null
            }

            this.paymentType = type
        },
    },
}
